import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { CompanyAdminService } from '../../services/companyadmin.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-saml-setting',
  templateUrl: './saml-setting.component.html',
  styleUrl: './saml-setting.component.scss',
})
export class SAMLSettingComponent implements OnInit {
  samlSettingForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private companyAdminService: CompanyAdminService,
    private messageService: MessageService,
    public ref: DynamicDialogRef,
  ) {}

  ngOnInit(): void {
    this.samlSettingForm = this.fb.group({
      entity_id: ['', [Validators.required]],
      login_url: ['', [Validators.required]],
      logout_url: ['', [Validators.required]],
      fingerprint: ['', [Validators.required]],
      certificate: ['', [Validators.required]],
      is_enabled: [false, [Validators.required]]
    });
    this.getSettings();
  }

  getSettings(){
    this.companyAdminService.getSamlSettings().subscribe({
      next: ( data ) =>{
        this.samlSettingForm.patchValue(data);
      },
      error: ({error}: any) =>{
        this.messageService.add({ severity: 'error', summary: 'Error', detail: `${error.error}` });
      }
    })
  }

  onSubmit(): void {
    if(this.samlSettingForm.valid){
      this.companyAdminService.editSamlSettings(this.samlSettingForm.value).subscribe({
        next: ( data ) =>{
          this.messageService.add({ severity: 'success', summary: 'Success', detail: `Setting Saved successfully.` });
          this.ref.close();
        },
        error: ({error}: any) =>{
          this.messageService.add({ severity: 'error', summary: 'Error', detail: `${error.error}` });
          // this.router.navigate(['/auth/login']);
        }
      })
    }
  }
  onCancel(){
    this.ref.close();
  }
}

